import React from 'react'
import Button from 'core/elements/button/Button'
import Text from 'core/elements/Text'
import ModalForm from 'core/elements/modal/ModalForm'
import Alert from 'core/components/Alert'
import { makeStyles } from '@material-ui/styles'
import Theme from 'core/themes/model'
import useUpdateAction from 'core/hooks/useUpdateAction'
import { toggleDeleteOnTermination } from './actions'

const useStyles = makeStyles<Theme>((theme) => ({
  'top-spacing': {
    marginTop: theme.spacing(3),
  },
}))

const DeleteOnTerminationDialog = ({ rows: [vm], onClose }) => {
  const classes = useStyles({
    theme: {},
  })

  const { update, updating, error } = useUpdateAction(toggleDeleteOnTermination)

  const volume = vm['os-extended-volumes:volumes_attached']?.[0]
  const deleteOnTermination = volume?.delete_on_termination
  const vmName = vm.name || vm.id
  const action = deleteOnTermination ? 'Disable' : 'Enable'

  const handleConfirm = async () => {
    const body = {
      volumeAttachment: {
        volumeId: volume?.id,
        delete_on_termination: !deleteOnTermination,
      },
    }

    const { success } = await update({
      id: vm?.id,
      volumeId: volume?.id,
      body,
    })
    if (success) onClose(true)
  }

  return (
    <ModalForm
      panel="dialog"
      open
      onClose={onClose}
      title={`${action} Root Volume Delete on Termination`}
      data-testid="delete-on-termination-modal"
      error={error}
      onSubmit={handleConfirm}
      submitting={updating}
      submitTitle={'Confirm'}
      maxWidth={600}
    >
      <Text variant="body2">
        You are about to <strong>{action.toLowerCase()}</strong> the setting to{' '}
        <strong>delete the root volume</strong> when VM <strong>{vmName}</strong> is terminated.
      </Text>

      {!deleteOnTermination && (
        <Alert
          variant="warning"
          className={classes['top-spacing']}
          message={
            <Text variant="body2">
              Warning: Enabling this option means the root volume will be{' '}
              <strong>permanently deleted</strong> if the VM is terminated. Ensure this is intended,
              as recovery will not be possible.{' '}
            </Text>
          }
        />
      )}

      {deleteOnTermination && (
        <Text variant="body2" className={classes['top-spacing'] || ''}>
          You can re-attach the volume manually in the future if you choose not to delete it during
          termination.
        </Text>
      )}
    </ModalForm>
  )
}

export default DeleteOnTerminationDialog
